<script lang="ts">
	import { page } from '$app/stores';
	import ScrollReveal from '$lib/components/ScrollReveal.svelte';
	import { t, type Language } from '$lib/i18n';

	let lang = $derived($page.params.lang as Language);
	let tr = $derived(t(lang));
</script>

<svelte:head>
	<title>{tr('privacy_page_title')}</title>
	<meta name="description" content={tr('privacy_page_desc')} />
</svelte:head>

<section class="relative pt-32 pb-20">
	<div class="absolute inset-0 bg-grid opacity-20"></div>

	<div class="relative max-w-3xl mx-auto px-6">
		<ScrollReveal>
			<p class="text-ameta-green font-medium mb-4 tracking-wide">{tr('privacy_label')}</p>
			<h1 class="text-4xl md:text-5xl font-bold mb-6">{tr('privacy_heading')}</h1>
			<p class="text-slate-400 mb-12">{tr('privacy_updated')}</p>
		</ScrollReveal>

		<div class="prose prose-invert prose-slate max-w-none">
			<ScrollReveal>
				<section class="mb-12">
					<h2 class="text-2xl font-bold mb-4 text-slate-100">{tr('privacy_who_title')}</h2>
					<p class="text-slate-400 leading-relaxed">
						{tr('privacy_who_desc')}
					</p>
				</section>
			</ScrollReveal>

			<ScrollReveal>
				<section class="mb-12">
					<h2 class="text-2xl font-bold mb-4 text-slate-100">{tr('privacy_what_title')}</h2>
					<p class="text-slate-400 leading-relaxed mb-4">{tr('privacy_what_intro')}</p>
					<ul class="list-disc list-inside text-slate-400 space-y-2">
						<li>
							<strong class="text-slate-300">{tr('privacy_what_contact')}</strong>
							{tr('privacy_what_contact_desc')}
						</li>
						<li>
							<strong class="text-slate-300">{tr('privacy_what_analytics')}</strong>
							{tr('privacy_what_analytics_desc')}
						</li>
						<li>
							<strong class="text-slate-300">{tr('privacy_what_technical')}</strong>
							{tr('privacy_what_technical_desc')}
						</li>
					</ul>
				</section>
			</ScrollReveal>

			<ScrollReveal>
				<section class="mb-12">
					<h2 class="text-2xl font-bold mb-4 text-slate-100">{tr('privacy_why_title')}</h2>
					<ul class="list-disc list-inside text-slate-400 space-y-2">
						<li>{tr('privacy_why_1')}</li>
						<li>{tr('privacy_why_2')}</li>
						<li>{tr('privacy_why_3')}</li>
					</ul>
				</section>
			</ScrollReveal>

			<ScrollReveal>
				<section class="mb-12">
					<h2 class="text-2xl font-bold mb-4 text-slate-100">{tr('privacy_legal_title')}</h2>
					<p class="text-slate-400 leading-relaxed">
						{tr('privacy_legal_desc')}
					</p>
				</section>
			</ScrollReveal>

			<ScrollReveal>
				<section class="mb-12">
					<h2 class="text-2xl font-bold mb-4 text-slate-100">{tr('privacy_sharing_title')}</h2>
					<p class="text-slate-400 leading-relaxed">
						{tr('privacy_sharing_desc')}
					</p>
				</section>
			</ScrollReveal>

			<ScrollReveal>
				<section class="mb-12">
					<h2 class="text-2xl font-bold mb-4 text-slate-100">{tr('privacy_storage_title')}</h2>
					<p class="text-slate-400 leading-relaxed">
						{tr('privacy_storage_desc')}
					</p>
				</section>
			</ScrollReveal>

			<ScrollReveal>
				<section class="mb-12">
					<h2 class="text-2xl font-bold mb-4 text-slate-100">{tr('privacy_rights_title')}</h2>
					<p class="text-slate-400 leading-relaxed mb-4">{tr('privacy_rights_intro')}</p>
					<ul class="list-disc list-inside text-slate-400 space-y-2">
						<li>{tr('privacy_rights_1')}</li>
						<li>{tr('privacy_rights_2')}</li>
						<li>{tr('privacy_rights_3')}</li>
						<li>{tr('privacy_rights_4')}</li>
						<li>{tr('privacy_rights_5')}</li>
						<li>{tr('privacy_rights_6')}</li>
						<li>{tr('privacy_rights_7')}</li>
						<li>{tr('privacy_rights_8')}</li>
					</ul>
				</section>
			</ScrollReveal>

			<ScrollReveal>
				<section class="mb-12">
					<h2 class="text-2xl font-bold mb-4 text-slate-100">{tr('privacy_automated_title')}</h2>
					<p class="text-slate-400 leading-relaxed">
						{tr('privacy_automated_desc')}
					</p>
				</section>
			</ScrollReveal>

			<ScrollReveal>
				<section class="mb-12">
					<h2 class="text-2xl font-bold mb-4 text-slate-100">{tr('privacy_cookies_title')}</h2>
					<p class="text-slate-400 leading-relaxed">
						{tr('privacy_cookies_desc')}
					</p>
				</section>
			</ScrollReveal>

			<ScrollReveal>
				<section class="mb-12">
					<h2 class="text-2xl font-bold mb-4 text-slate-100">{tr('privacy_contact_title')}</h2>
					<p class="text-slate-400 leading-relaxed">
						{tr('privacy_contact_desc')}
						<a href="mailto:hello@ameta.no" class="text-ameta-green hover:underline"
							>hello@ameta.no</a
						>.
					</p>
				</section>
			</ScrollReveal>
		</div>
	</div>
</section>
